import { View } from "react-native";
import "../global.css";

export default function App() {
  return (
    <View style={{ width: "100%", flex: 1, padding: 24 }}>
      <View className="bg-blue-500 w-40 h-40"></View>

      <View style={{ marginTop: 10 }}></View>
    </View>
  );
}
